import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"
import { AdminMercadoPagoQuery } from "../../Objects/AdminDashboard/AdminMercadoPagoQuery"
import { AdminMercadoPagoQueryResult } from "../../Objects/AdminDashboard/AdminMercadoPagoQueryResult"
import { useTranslation } from "react-i18next"
import { useState } from "react"

export const useAdminMercadoPagoQuery = () => {
  const { t } = useTranslation("frontend")

  const [isQuerying, setIsQuerying] = useState(false)

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleQuery = async (
    request: AdminMercadoPagoQuery,
    onSuccess: (data: AdminMercadoPagoQueryResult) => void,
  ) => {
    if (isQuerying) {
      return
    }

    setIsQuerying(true)
    enableLoad()

    try {
      const response = await PostRequest<AdminMercadoPagoQueryResult>(
        API_ROUTES.ADMIN_DASHBOARD.MERCADO_PAGO_QUERY,
        request,
        ERequestType.Admin,
      )

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess(new AdminMercadoPagoQueryResult(response.data ?? {}))
    } catch (ex) {
      const message = ex instanceof Error ? ex.message : t("admin_dashboard.mercado_pago_queries.error_default")

      setError(t("admin_dashboard.mercado_pago_queries.error_title"), message)
    } finally {
      setIsQuerying(false)
      disableLoad()
    }
  }

  return { handleQuery, isQuerying }
}
